export default {"src":"/_next/static/media/compressed-travolta.7bfc6f2e.gif","height":200,"width":206,"blurWidth":0,"blurHeight":0};